import { promptCrudConfig } from '@/config/objects/prompts';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Settings > Prompts list page.
 * Displays all prompts in a filterable, searchable table with create/edit/delete actions.
 */
export function PromptsPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Settings', href: '/settings/prompts' },
    { label: 'Prompts', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView
        config={promptCrudConfig}
        baseUrl="/settings/prompts"
        breadcrumbs={breadcrumbs}
      />
    </PageContainer>
  );
}
